import React from "react";
import { Select, Col } from "antd";
const { Option } = Select;

export const FormSelect = (props) => {
  return (
    <>
      <Select
        className="formInput"
        name="status"
        onChange={props.onChange}
        value={props.value}
        defaultValue="MANUAL AVOID"
      >
        <Option
          key="0"
          disabled={!(props.value === "Waiting For Activation")}
          value="Manual Avoid"
        >
          Manual Avoid
        </Option>
        <Option
          key="1"
          disabled={!(props.value === "Activated")}
          value="Manual Exit"
        >
          Manual Exit
        </Option>
      </Select>
    </>
  );

  // return (
  //   <>
  //     {props.role == "advisor" ? (
  //       <Select
  //         className="formInput"
  //         name="status"
  //         onChange={props.onChange}
  //         value={props.value}
  //         defaultValue="MANUAL AVOID"
  //       >
  //         <Option
  //           key="0"
  //           disabled={!(props.value === "Waiting For Activation")}
  //           value="Manual Avoid"
  //         >
  //           Manual Avoid
  //         </Option>
  //         <Option
  //           key="1"
  //           disabled={!(props.value === "Activated")}
  //           value="Manual Exit"
  //         >
  //           Manual Exit
  //         </Option>
  //       </Select>
  //     ) : (
  //       <Select
  //         className="formInput"
  //         name="status"
  //         onChange={props.onChange}
  //         value={props.value}
  //         defaultValue="MANUAL AVOID"
  //       >
  //         <Option key="0" value="Waiting For Activation">
  //           Waiting For Activation
  //         </Option>
  //         <Option key="1" value="Activated">
  //           Activated
  //         </Option>
  //         <Option key="2" value="Target Hit">
  //           Target Hit
  //         </Option>
  //         <Option key="3" value="Stop Loss Hit">
  //           Stop Loss Hit
  //         </Option>
  //         <Option key="4" value="Manual Avoid">
  //           Manual Avoid
  //         </Option>
  //         <Option key="5" value="Manual Exit">
  //           Manual Exit
  //         </Option>
  //         <Option key="6" value="Expired">
  //           Expired
  //         </Option>
  //       </Select>
  //     )}
  //   </>
  // );
};
